import React from "react";
import MetaTags from "components/MetaTags";
import API from "strapi/api";
import AnimatedBox from "components/Elements/AnimatedBox";
import { ContainerWithOffset } from "components/Elements/Container";
import ButtonTicker from "components/Elements/ButtonTicker";
import { PopupButton } from "@typeform/embed-react";
import parse from "html-react-parser";

export default function Contact(props) {
  return (
    <>
      <MetaTags
        title={
          props.content.meta_info && props.content.meta_info.meta_title
            ? props.content.meta_info.meta_title
            : "CONTACT"
        }
        description={
          props.content.meta_info && props.content.meta_info.meta_description
            ? props.content.meta_info.meta_description
            : "Contact - ZANAD | An Independent Animation Production Studio"
        }
        image={
          props.content.meta_info && props.content.meta_info.og_image
            ? API.getNextImage(props.content.meta_info.og_image, "large")
            : "/public/og-image.jpg"
        }
      />
      <main className="mb-44">
        <ContainerWithOffset>
          <h1 className="offscreen-title ">Contacts</h1>
          <div className="grid grid-cols-1 gap-10 1024:grid-cols-2">
            <h2 className="mt-8 uppercase fluid-type">
              <span className="block">
                <AnimatedBox num={4}>
                  <span className="optical-align letter-r">Ready </span>
                </AnimatedBox>
                <AnimatedBox num={1}>
                  <span className="">to </span>
                </AnimatedBox>
                <AnimatedBox num={3}>
                  <span className="">get</span>
                </AnimatedBox>
              </span>
              <span className="block text-right 1024:text-left">
                <AnimatedBox num={2}>
                  <span className="optical-align letter-y">your </span>
                </AnimatedBox>
                <AnimatedBox num={5}>
                  <span className="">idea </span>
                </AnimatedBox>
              </span>
              <span className="block indent-0 1024:indent-20 1024:indent-36">
                <AnimatedBox num={6}>
                  <span className="">“moving”</span>
                </AnimatedBox>
                <AnimatedBox num={2}>
                  <span className="">?</span>
                </AnimatedBox>
              </span>
            </h2>
            <div className="mt-4 1024:mt-16 1280:mt-16 1440:mt-28">
              <PopupButton
                id="NHTrYKkM"
                className="block btn-ticker-full whitespace-nowrap rounded-[50%] bg-black border-black border-[3px] fluid-type-small-v2 text-white uppercase overflow-hidden mb-10"
              >
                <span className="btn-ticker-inner-v2">
                  <span data-text="Let's Spark ">
                    <em className="not-italic glyph-icon">0</em>
                    Let&apos;s Spark{" "}
                    <em className="not-italic glyph-icon">0 </em>
                    Let&apos;s Spark{" "}
                    <em className="not-italic glyph-icon">0 </em>
                    Let&apos;s Spark{" "}
                    <em className="not-italic glyph-icon">0 </em>
                  </span>
                </span>
              </PopupButton>
              <div className="grid grid-cols-1 gap-4 uppercase 640:grid-cols-3 content-with-glyphs text-contacts">
                <p>
                  {props.content.conversation ? (
                    parse(props.content.conversation)
                  ) : (
                    <></>
                  )}
                </p>
                <p>
                  {props.content.careers ? parse(props.content.careers) : <></>}
                </p>
              </div>
            </div>
          </div>
        </ContainerWithOffset>
      </main>
    </>
  );
}

export async function getStaticProps(ctx) {
  const content = await API.getSingleType("contact");

  return {
    props: {
      content: content,
    },
    revalidate: 10,
  };
}
